import Dinero from "dinero.js";

/**
 * Formats an amount given in EUR cents as a localized currency string.
 */
export const formatAmount = (cents: number): string => Dinero({amount: cents}).toFormat();

/**
 * Turns a slug like "database-servers" into a human-readable label ("Database Servers").
 */
export const formatCategoryLabel = (slug: string): string =>
    slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

/**
 * Formats an amount given in EUR cents as a localized currency string rounded to whole euros,
 * for overviews where cents only distract.
 */
export const formatWholeAmount = (cents: number): string => Dinero({amount: Math.round(cents)}).toFormat('$0,0');
